module.exports = __webpack_public_path__ + "static/yuan_ti_sacrifice-68347179db20d061fae39777fab292e9.jpg";